import { render, staticRenderFns } from "./notAllowed.vue?vue&type=template&id=f30f6ff2&scoped=true"
import script from "./notAllowed.vue?vue&type=script&lang=js"
export * from "./notAllowed.vue?vue&type=script&lang=js"
import style0 from "./notAllowed.vue?vue&type=style&index=0&id=f30f6ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30f6ff2",
  null
  
)

export default component.exports